// Ninaa Beauty — contenu du site vitrine

export const PLANITY_URL = "https://www.planity.com/ninaa-beauty-31500-toulouse";

export const IMAGES = {
  heroBanner:
    "https://customer-assets-wrfwihn1.emergentagent.net/job_site-studio-342/artifacts/hrw3g9ea_IMG_2540.JPG",
  institut:
    "https://customer-assets-wrfwihn1.emergentagent.net/job_site-studio-342/artifacts/vvorey7y_IMG_3098%20%282%29.webp",
  massagesBanner:
    "https://images.unsplash.com/photo-1741522509438-a120c0bb5e88?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwxfHxyZWxheGluZyUyMGZ1bGwlMjBib2R5JTIwb2lsJTIwbWFzc2FnZSUyMHNwYXxlbnwwfHx8fDE3ODYwNTQ1OTN8MA&ixlib=rb-4.1.0&q=85",
  wellbeing:
    "https://customer-assets-wrfwihn1.emergentagent.net/job_site-studio-342/artifacts/hvln2bnx_IMG_2528.jpeg",
  approcheArt:
    "https://customer-assets-wrfwihn1.emergentagent.net/job_site-studio-342/artifacts/f0fuzq71_IMG_3957.jpeg",
};

export const NAV = [
  { label: "Accueil", to: "/", type: "route" },
  {
    label: "Prestations",
    type: "dropdown",
    children: [
      { label: "Épilations", to: "/prestations/epilations", type: "route" },
      { label: "Massages & bien-être", to: "/massages", type: "route" },
      { label: "Beauté du regard & sourcils", to: "/prestations/beaute-du-regard", type: "route" },
      { label: "Soins du visage", to: "/prestations/soins-du-visage", type: "route" },
    ],
  },
  { label: "Massages & bien-être", type: "dropdown", to: "/massages", children: [
      { label: "Massage californien", to: "/massages/massage-californien", type: "route" },
      { label: "Massage femme enceinte", to: "/massages/massage-femme-enceinte", type: "route" },
      { label: "Voir tous les massages", to: "/massages", type: "route" },
    ],
  },
  { label: "L'Institut", to: "/institut", type: "route" },
  { label: "Carte cadeau", to: "carte-cadeau", type: "hash" },
  { label: "Contact", to: "contact", type: "hash" },
];

export const ABOUT_TEXT =
  "Ninaa Beauty est un institut de beauté à taille humaine, dédié au bien-être et à la douceur. Chaque soin y est pensé comme une parenthèse, avec des gestes attentifs et des produits respectueux de votre peau. Un lieu calme et chaleureux, où l'on prend simplement le temps de prendre soin de vous.";

export const SERVICES = [
  {
    slug: "epilations",
    name: "Épilations",
    desc: "À la cire tiède, précise et respectueuse de la peau",
    description:
      "Chez Ninaa Beauty, chaque épilation est réalisée avec précision et douceur.\n\nLa cire est appliquée à la spatule et retirée dans le respect du sens naturel du poil afin de limiter sa casse et favoriser une repousse plus régulière. Des cires de qualité, adaptées aux peaux sensibles, sont soigneusement sélectionnées pour offrir un résultat propre et confortable.\n\nDes conseils vous sont également proposés pour prolonger les résultats après votre rendez-vous.",
    duration: "sur devis",
    price: "dès 12 €",
    hideBadge: true,
    hidePrice: true,
    image:
      "https://customer-assets-wrfwihn1.emergentagent.net/job_site-studio-342/artifacts/d80rcdc4_IMG_2520.JPG",
  },
  {
    slug: "massages-bien-etre",
    name: "Massages & Bien-être",
    desc: "Massages sur mesure pour relâcher le corps et apaiser l'esprit",
    description:
      "Des massages doux et sur mesure pour relâcher le corps, apaiser l'esprit et se reconnecter à soi.",
    duration: "sur mesure",
    price: "dès 65 €",
    hideBadge: true,
    link: "/massages",
    image:
      "https://customer-assets-wrfwihn1.emergentagent.net/job_site-studio-342/artifacts/wvicw1ej_IMG_2521.JPG",
  },
  {
    slug: "beaute-du-regard",
    name: "Beauté du regard & Sourcils",
    desc: "Rehaussement de cils, teinture & sourcils",
    description:
      "Du rehaussement de cils au brow lift, chaque prestation est pensée pour mettre naturellement votre regard en valeur.\n\nAvec ou sans teinture, les soins sont réalisés avec précision afin d'obtenir un résultat harmonieux et durable.\n\nLes restructurations des sourcils viennent compléter ces prestations pour redessiner et mettre naturellement le regard en valeur.",
    duration: "sur mesure",
    price: "dès 50 €",
    hideBadge: true,
    image:
      "https://customer-assets-wrfwihn1.emergentagent.net/job_site-studio-342/artifacts/m1izcw2g_IMG_2523.JPG",
  },
  {
    slug: "soins-du-visage",
    name: "Soins du visage",
    desc: "Nettoyage, gommage, massage et masque adapté à votre peau.",
    label: "Prestation",
    hideBadge: true,
    hidePrice: true,
    description:
      "Les soins du visage sont réalisés avec des produits soigneusement sélectionnés, privilégiant des formulations et des actifs d'origine naturelle, adaptés aux besoins de votre peau.\n\nLes massages du visage viennent compléter ces soins et prolonger leurs bienfaits par une détente profonde.",
    duration: "1 h 15",
    price: "75 €",
    image:
      "https://customer-assets-wrfwihn1.emergentagent.net/job_site-studio-342/artifacts/xzs9z2cz_IMG_2807.JPG",
  },
];

export const MASSAGES = [
  {
    slug: "massage-californien",
    name: "Massage Californien",
    category: "Massage",
    tagline: "Le lâcher-prise absolu.",
    excerpt: "Des mouvements longs, fluides et enveloppants invitent progressivement le corps et l'esprit à relâcher les tensions…",
    text: "Des mouvements longs, fluides et enveloppants invitent progressivement le corps et l'esprit à relâcher les tensions pour laisser place à une profonde détente.",
    description:
      "Des mouvements longs, fluides et enveloppants invitent progressivement le corps et l'esprit à relâcher les tensions pour laisser place à une profonde détente.",
    benefits: ["Relâcher les tensions", "Apaiser le mental", "Retrouver une sensation de légèreté"],
    duration: "1 h 15",
    price: "75 €",
    meta: "1h15 · 75 €",
    installNote: true,
    image:
      "https://customer-assets-wrfwihn1.emergentagent.net/job_site-studio-342/artifacts/as71rawj_IMG_2803%20%281%29.JPG",
  },
  {
    slug: "massage-femme-enceinte",
    name: "Massage Femme Enceinte",
    category: "Massage",
    tagline: "Une parenthèse pour vous et votre corps.",
    excerpt: "Ce massage accompagne les changements du corps avec douceur, aide à soulager les tensions liées à la grossesse et offre un véritable moment de calme pour la maman comme pour son bébé…",
    note: "À partir du 2ᵉ trimestre de grossesse.",
    text: "Pensé pour les futures mamans à partir du deuxième trimestre de grossesse, ce massage accompagne les changements du corps avec douceur. Il aide à soulager les tensions musculaires liées à la grossesse, favorise la détente et offre un véritable moment de calme pour la maman comme pour son bébé.",
    description:
      "Au fil de la grossesse, le corps change et certaines tensions peuvent apparaître : dos plus sollicité, jambes plus lourdes, fatigue ou simplement besoin de souffler. Pensé pour accompagner cette période, ce massage enveloppant aide à soulager les tensions et à retrouver davantage de confort.\n\nUn moment entièrement consacré à la future maman, pour se détendre, se reconnecter à ses sensations et profiter d'une parenthèse à deux, avec son bébé.",
    benefits: ["Soulager les tensions liées à la grossesse", "Retrouver davantage de confort", "S'accorder un moment pour soi"],
    duration: "1 h 15",
    price: "80 €",
    meta: "1h15 · 80 €",
    installNote: true,
    image:
      "https://images.unsplash.com/photo-1680987218595-2d514938a72c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwzfHxwcmVuYXRhbCUyMHByZWduYW5jeSUyMG1hc3NhZ2UlMjBiZWxseSUyMGNhcmV8ZW58MHx8fHwxNzg2MDU0NTkzfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "massage-holistique-intuitif",
    name: "Massage Holistique Intuitif",
    category: "Massage",
    tagline: "Un soin qui vous ressemble.",
    excerpt: "Ce massage intuitif s'adapte entièrement à ce que votre corps exprime au moment de la séance…",
    text: "Ce massage intuitif s'adapte entièrement à ce que votre corps exprime au moment de la séance. Les manœuvres évoluent naturellement au fil du massage afin de répondre à vos besoins du moment.",
    description:
      "Le massage holistique intuitif s'adapte à ce que votre corps exprime et à ce dont vous avez besoin au moment de la séance. Les gestes s'adaptent naturellement au fil du massage, selon vos besoins et vos ressentis.\n\nUn moment pour se retrouver, relâcher ce qui pèse et laisser place à davantage de sérénité et d'équilibre intérieur.\n\nLes instruments sonores viennent enrichir le massage, approfondir la détente et laisser place à un voyage hors du temps.",
    benefits: ["Se retrouver", "Relâcher ce qui encombre", "Retrouver un équilibre intérieur"],
    duration: "1 h 30",
    price: "90 €",
    meta: "1h30 · 90 €",
    installNote: true,
    image:
      "https://customer-assets-wrfwihn1.emergentagent.net/job_site-studio-342/artifacts/tejqwdjx_IMG_2683.jpeg",
  },
  {
    slug: "soin-rebozo",
    name: "Soin Rebozo",
    category: "Soin",
    tagline: "Se recentrer, se réancrer.",
    excerpt: "Un soin enveloppant qui accompagne les passages de vie, la maternité ou l'envie de revenir à soi. Bercements, enveloppements et resserrages invitent à un véritable moment de reconnexion.",
    hidePrice: true,
    comingSoon: true,
    text: "Un soin particulièrement pensé pour le post-partum, offrant un temps de relaxation profonde, de repos et de reconnexion à soi après la grossesse et l'accouchement.",
    description:
      "Un soin particulièrement pensé pour le post-partum, offrant un temps de relaxation profonde, de repos et de reconnexion à soi après la grossesse et l'accouchement. Le Rebozo accompagne ce moment à travers des bercements, des enveloppements et des gestes favorisant le relâchement.\n\nIl peut également être proposé lors d'autres moments de transition, ou simplement dans une recherche de relaxation et de détente.",
    benefits: ["Revenir à soi", "Se sentir enveloppée", "Retrouver ses sensations"],
    intro: [
      "D'origine mexicaine, le Rebozo est une pratique ancestrale qui accompagne les femmes à différents moments de leur vie : en lien avec la maternité, lors d'une transition, après un événement marquant ou lorsque l'on ressent le besoin de revenir à soi, de s'accorder de l'attention ou de trouver du réconfort.",
      "De longues écharpes traditionnelles tissées, appelées rebozos, viennent bercer, envelopper puis délicatement resserrer différentes parties du corps. Le soin se reçoit habillée, dans une tenue confortable. Une fois installée, laissez-vous guider par les bercements et les enveloppements du Rebozo.",
      "Le Rebozo offre un véritable rendez-vous avec soi. Il trouve particulièrement sa place dans ces périodes où il devient difficile de s'accorder de l'attention. Le contact se faisant principalement à travers les étoffes, il peut aussi être une première approche rassurante pour les femmes qui n'osent pas encore recevoir un massage ou qui sont moins à l'aise avec le toucher direct.",
    ],
    maternityTitle: "Autour de la maternité",
    maternityIntro:
      "Après la naissance, le Rebozo offre à la nouvelle maman une parenthèse pour elle. Les resserrages, notamment autour du bassin, accompagnent symboliquement la fermeture de cette période et permettent de retrouver peu à peu ses sensations et cette présence à son corps.",
    maternityNote:
      "Ce soin peut être reçu à partir de 6 à 8 semaines après l'accouchement, lorsque la récupération le permet.",
    maternityClose:
      "La séance se termine par un massage relaxant des bras et du visage, pour prolonger cet instant de sérénité et de reconnexion.",
    conclusion:
      "Un véritable soin du cœur, une invitation à se retrouver, se ressentir et renouer avec son harmonie intérieure.",
    aSavoir:
      "Après une césarienne, attendre une cicatrisation complète et l'accord d'un professionnel de santé avant de recevoir le soin.",
    duration: "1 h 15 à 1 h 30",
    price: "90 €",
    meta: "1 h 15 à 1 h 30 • 90 €",
    image:
      "https://customer-assets-wrfwihn1.emergentagent.net/job_site-studio-342/artifacts/rxfd1egl_IMG_2527.jpeg",
  },
  {
    slug: "bain-sonore",
    name: "Bain Sonore",
    category: "Bien-être",
    tagline: "Se laisser porter par les sons.",
    excerpt: "Fermez les yeux et laissez les sons vous porter : un véritable voyage sonore où chaque vibration vous enveloppe et vous emporte, tout doucement…",
    hidePrice: true,
    comingSoon: true,
    text: "Fermez les yeux et laissez les sons vous porter : les vibrations des bols, du tambour océan et des Koshi vous enveloppent dans un véritable voyage sonore.",
    description:
      "Fermez les yeux et entrez peu à peu dans l'univers des sons et des vibrations.\n\nBols, tambour océan, Koshi et autres instruments se mêlent pour vous entraîner dans un véritable voyage sonore, propice au relâchement et à l'apaisement.\n\nConfortablement installée, vous n'avez rien à faire. Les sons se succèdent et vous accompagnent progressivement vers une détente profonde et un mental plus calme.",
    benefits: ["Calmer le mental", "Favoriser une profonde relaxation", "S'offrir un moment hors du temps"],
    duration: "1 h",
    price: "85 €",
    meta: "1h · 85 €",
    image:
      "https://customer-assets-wrfwihn1.emergentagent.net/job_site-studio-342/artifacts/jw3n2rbh_IMG_2571.JPG",
  },
];

export const GALLERY = [
  { src: IMAGES.wellbeing, alt: "L'ambiance cocooning de l'institut Ninaa Beauty" },
  { src: SERVICES[3].image, alt: "Soin du visage sur mesure" },
  { src: SERVICES[2].image, alt: "Beauté du regard — rehaussement de cils" },
  { src: SERVICES[1].image, alt: "Massage bien-être" },
  { src: MASSAGES[3].image, alt: "Soin Rebozo" },
  { src: SERVICES[0].image, alt: "Épilation à la cire tiède" },
];

export const WELLBEING = {
  quote:
    "Prendre soin de soi, c'est aussi revenir à soi. S'accorder un moment pour relâcher, s'écouter et retrouver un peu plus de bien-être.",
  words: ["Respirer.", "S'autoriser.", "Relâcher.", "Se retrouver."],
};

export const REVIEWS = {
  rating: "5,0",
  count: "106",
  items: [
    {
      author: "Lisa R.",
      text: "J'ai passé un excellent moment ! Le salon est très propre, bien aménagé, et on s'y sent tout de suite à l'aise. Ninaa est à la fois très professionnelle, douce et à l'écoute. C'est un vrai plaisir de confier ses soins à quelqu'un d'aussi attentionnée. Je recommande vivement !",
    },
    {
      author: "Maria H.",
      text: "Esthéticienne très professionnelle et attentive aux détails. Le travail était parfait et je me suis sentie tout de suite à l'aise. En plus, elle est très gentille et disponible. Je recommande vivement !",
    },
    {
      author: "Marine L.",
      text: "J'ai fait un rehaussement de cils et une restructuration de sourcils chez Ninaa Beauty, et le résultat est juste parfait ! Nina a été super accueillante, douce et très attentive aux moindres détails. L'institut est cosy et agréable. Une super adresse que je recommande les yeux fermés.",
    },
    {
      author: "Céline D.",
      text: "Massage californien au top ! Un moment de relâchement complet, une masseuse aux doigts de fée, détente garantie ! Je recommande !!!",
    },
    {
      author: "Laura F.",
      text: "Je suis venue chez Ninaa Beauty pour une épilation et Nina a été au top, très douce et très minutieuse. Je reviendrai sans hésiter !!",
    },
    {
      author: "Kahina O.",
      text: "Première fois ici et belle surprise ! Un accueil tout en douceur, un espace propre, lumineux et cocooning… Nina a réussi à transformer la douleur de l'épilation en un moment de douceur par son professionnalisme. Je suis ressortie détendue. Je recommande sans hésiter et je reviendrai :)",
    },
    {
      author: "Juliette A.",
      text: "Très bonne expérience épilation ! Un service d'une grande qualité. Je recommande.",
    },
  ],
};

export const FAQ = [
  {
    q: "Comment se déroule un rendez-vous chez Ninaa Beauty ?",
    a: "Chaque rendez-vous débute par un court échange afin de faire le point sur la prestation choisie et vos besoins. La prestation est ensuite réalisée dans le temps qui lui est entièrement consacré.",
  },
  {
    q: "Quelle est la politique de prise de rendez-vous et d'annulation ?",
    a: "Les rendez-vous peuvent être annulés directement depuis Planity jusqu'à 20 h avant l'horaire prévu. Passé ce délai, merci de me contacter directement par téléphone ou par message.\n\nAnnulation par SMS au 07 44 97 22 82.\n\nEn cas d'annulations tardives répétées, la prise de rendez-vous en ligne pourra être désactivée. Pour les prestations soumises à un acompte, celui-ci n'est pas remboursé en cas d'annulation tardive ou de non-présentation au rendez-vous.",
  },
  {
    q: "Où se situe l'institut et comment y accéder ?",
    a: "Ninaa Beauty se situe au 31 rue du Rempart Matabiau, 31000 Toulouse. À votre arrivée, merci de vous annoncer à l'interphone Ninaa Beauty avant de monter, même lorsque la porte de l'immeuble est déjà ouverte.",
  },
];

export const CONTACT = {
  address: "31 rue du Rempart Matabiau, 31000 Toulouse",
  googlePlaceName: "Ninaa Beauty - Esthéticienne Toulouse Centre",
  googleShareUrl: "https://share.google/g6mLcfzxm0BmIiRgc",
  phone: "07 44 97 22 82",
  email: "ninaa.beaauty@gmail.com",
  instagram: "https://www.instagram.com/ninaa_beaauty",
  hours: [
    { d: "Lundi", h: "13h15 à 19h00" },
    { d: "Mardi – Vendredi", h: "10h15 à 19h00" },
    { d: "Samedi – Dimanche", h: "Fermé" },
  ],
};


// Épilation — informations pratiques (compléments à la page Épilations)
export const EPILATION_EXTRAS = {
  // Carte des épilations — page 1 (prestations)
  cardImage:
    "https://customer-assets-wrfwihn1.emergentagent.net/job_site-studio-342/artifacts/qn3gjrcb_Menu%20Cocktail%20Boissons%20Restaurant%20Bar%20Oriental%20Moderne%20-%201.JPG",
  // Carte des épilations — page 2 (forfaits)
  extraImage:
    "https://customer-assets-wrfwihn1.emergentagent.net/job_site-studio-342/artifacts/q5n2sc3j_Menu%20Cocktail%20Boissons%20Restaurant%20Bar%20Oriental%20Moderne%20-%202.JPG",
  prep: [
    {
      t: "Pour une épilation optimale",
      d: "Une longueur de poil d'environ 3 à 5 mm permet à la cire de bien accrocher.",
    },
    {
      t: "Après un rasage",
      d: "Prévoyez au moins deux semaines de repousse pour une épilation plus nette et homogène.",
    },
    {
      t: "Épilation du maillot pendant les règles",
      d: "L'épilation du maillot reste possible pendant les règles, avec une protection interne (tampon ou cup).",
    },
    {
      t: "En cas de repousse importante",
      d: "Après une longue période sans épilation, un supplément de 5 € peut s'appliquer pour le temps de travail supplémentaire.",
    },
  ],
  modelage: {
    title: "Modelage des jambes",
    meta: "10 min · 12 €",
    text: "À ajouter à votre épilation pour terminer le rendez-vous par quelques minutes de détente.",
  },
};

// Le Vajacial — soin de la peau de la zone intime externe (page dédiée /vajacial)
export const VAJACIAL = {
  title: "Le Vajacial",
  subtitle: "Un soin conçu pour la peau de la zone intime.",
  image:
    "https://customer-assets-wrfwihn1.emergentagent.net/job_site-studio-342/artifacts/f36h2wrc_IMG_2937.JPG",
  included: "Épilation comprise",
  periodNote: "Possible pendant les règles avec tampon ou cup",
  intro:
    "Un soin pensé pour prendre soin de la peau de la zone intime externe, notamment en cas de poils incarnés, d'irrégularités, de peau rugueuse, de sécheresse ou d'hyperpigmentation.",
  // Étiquettes courtes (page Épilations)
  tags: ["Poils incarnés", "Hyperpigmentation", "Peau rugueuse", "Peau sèche"],
  // « Pour qui ? »
  concerns: [
    "Poils incarnés",
    "Hyperpigmentation",
    "Irrégularités ou peau rugueuse",
    "Peau sèche",
    "Une zone qui nécessite davantage de soin",
  ],
  // Ce soin comprend (formulation naturelle, rassurante)
  includes:
    "Un gommage adapté, l'épilation de la zone, l'extraction des poils incarnés, l'application de produits adaptés aux besoins de la peau et un masque choisi selon la problématique.",
  // Durée & tarif (présentation sobre, harmonisée avec les autres prestations)
  duration: "1h30",
  price: "80 €",
  // Témoignages spécifiques au Vajacial (carrousel éditorial)
  testimonials: [
    {
      name: "Lorianne",
      text:
        "Je suis absolument ravie de cette expérience ! C'était une expérience formidable ! Accueil chaleureux, produits de qualité et soin réalisé avec douceur. Ma peau est éclatante et douce. Merci pour ce moment de bien-être, je recommande vivement !",
    },
    {
      name: "Stéphanie",
      text:
        "Je suis venue pour une prestation de Vajacial (ma première fois d'ailleurs) et Ninaa a été très professionnelle. Super méticuleuse et douce. Je la recommande fortement… J'ai déjà pris mon prochain rendez-vous !",
    },
  ],
};


// Beauté du regard — les prestations détaillées (photos & tarifs)
export const REGARD_PREP =
  "Venir avec les yeux et les sourcils démaquillés.";

export const REGARD_NOTE =
  "D'autres packs et déclinaisons sont disponibles lors de votre réservation sur Planity.";

export const REGARD_SERVICES = [
  {
    name: "Rehaussement de cils",
    sentence:
      "Lifte et courbe les cils naturels dès la racine pour ouvrir et intensifier le regard, tout en conservant un résultat naturel.",
    priceLines: [
      { label: "Sans teinture", price: "70 €" },
      { label: "Avec teinture", price: "75 €" },
    ],
    duration: "1h15 à 1h30",
    image:
      "https://customer-assets-wrfwihn1.emergentagent.net/job_site-studio-342/artifacts/rraa30ge_IMG_1640.JPG",
    imgPos: "center 62%",
  },
  {
    name: "Browlift",
    sentence:
      "Discipline, structure et met en valeur les sourcils tout en conservant un résultat naturel.",
    options: [
      { label: "Browlift seul", meta: "60 €" },
      { label: "Avec coloration ou épilation", meta: "70 €" },
    ],
    duration: "1h à 1h15",
    image:
      "https://customer-assets-wrfwihn1.emergentagent.net/job_site-studio-342/artifacts/0m5ovc6c_IMG_2829.JPG",
    imgPos: "center 68%",
  },
  {
    name: "BrowPerfect",
    variant: "Browlift • Coloration • Épilation",
    sentence:
      "Une formule complète pour restructurer, discipliner et définir les sourcils.",
    meta: "1h30 · 80 €",
    included: "Épilation comprise",
    image:
      "https://customer-assets-wrfwihn1.emergentagent.net/job_site-studio-342/artifacts/6gdkavth_IMG_2800.JPG",
  },
  {
    name: "Teinture hybride des sourcils",
    sentence:
      "Intensifie la ligne et apporte davantage de définition au sourcil, sans Browlift.",
    meta: "1h15 · 50 €",
    included: "Épilation comprise",
    image:
      "https://customer-assets-wrfwihn1.emergentagent.net/job_site-studio-342/artifacts/rwguqer0_IMG_2799.JPG",
  },
  {
    name: "Restructuration & épilation des sourcils",
    sentence:
      "Redessine la ligne du sourcil en respectant sa forme naturelle et l'équilibre du visage.",
    meta: "30 min · 28 €",
    included: "Épilation comprise",
    image:
      "https://customer-assets-wrfwihn1.emergentagent.net/job_site-studio-342/artifacts/lsdzd7jm_IMG_2826.JPG",
  },
];

// Soins du visage — déclinaison
export const VISAGE_PREP =
  "Merci de venir le visage démaquillé.";

export const VISAGE_SERVICES = [
  {
    name: "Soin du visage adapté aux besoins de la peau",
    soon: true,
    sentence:
      "Un soin pensé selon les besoins de votre peau, pour lui apporter ce dont elle a besoin au moment du rendez-vous.",
    image:
      "https://customer-assets-wrfwihn1.emergentagent.net/job_site-studio-342/artifacts/017b1gke_IMG_2844.JPG",
  },
  {
    name: "Soin visage enveloppant",
    soon: true,
    sentence:
      "Un soin profondément réconfortant mêlant gestes enveloppants et relaxation du visage, du buste, des bras et des mains, pour prendre soin de la peau tout en laissant place à la détente.",
    image:
      "https://customer-assets-wrfwihn1.emergentagent.net/job_site-studio-342/artifacts/o56c9g2v_IMG_2805%20%281%29.JPG",
  },
  {
    name: "Massage relaxant du visage",
    sentence:
      "Un massage à l'huile du visage, du buste et des bras, entièrement consacré au relâchement et à la détente.",
    meta: "45 min · 50 €",
    image:
      "https://customer-assets-wrfwihn1.emergentagent.net/job_site-studio-342/artifacts/i6rgq6t4_IMG_2834.JPG",
  },
  {
    name: "Soin Boost Jeunesse",
    sentence:
      "Un soin tonifiant qui ravive l'éclat et stimule la vitalité du visage. Des gestes ciblés viennent réveiller les traits et apporter un véritable coup de frais à la peau. Le visage paraît plus frais, lumineux et rayonnant.",
    meta: "45 min · 50 €",
    image:
      "https://customer-assets-wrfwihn1.emergentagent.net/job_site-studio-342/artifacts/fkznl3e8_IMG_2862.JPG",
    imgPos: "center 35%",
  },
];


// Page L'institut — contenu éditorial (textes fournis, à conserver à l'identique)
export const INSTITUT_CONTENT = {
  welcomeTitle: "Bienvenue chez Ninaa Beauty.",
  welcome: [
    "Un espace imaginé pour celles qui aiment prendre soin d'elles, mais aussi pour celles qui ne s'accordent pas toujours ce temps.",
    "Ninaa Beauty réunit ainsi beauté et bien-être dans un espace intimiste, où chaque rendez-vous devient une parenthèse agréable, quelle que soit la prestation choisie. Un moment que l'on prend plaisir à s'accorder et dont on aimerait garder encore un peu la sensation une fois la porte refermée…",
  ],
  institut: [
    "Ninaa Beauty est né d'une envie : créer un institut qui ne soit pas figé dans une seule voie, ni dans une seule manière de prendre soin de soi.",
    "Un lieu où la beauté et le bien-être se rencontrent, laissant naturellement une place à de nouvelles pratiques, à mes inspirations et à ce que j'ai envie de transmettre.",
    "Cette évolution se construit avec créativité et ressenti, avec l'envie de proposer une approche plus complète, loin d'une simple accumulation de prestations.",
  ],
  approcheTitle: "Une approche qui considère l'ensemble",
  approche: [
    "Le corps et l'esprit ne vivent pas séparément. Le rythme du quotidien peut parfois nous éloigner de nos sensations et de ce qui compte pour nous.",
    "Prendre soin de soi, c'est aussi s'accorder un espace, être attentive à ce que l'on ressent et revenir à soi.",
    "Chez Ninaa Beauty, cette approche accompagne ma manière de prendre soin : un moment pour se recentrer, relâcher et simplement profiter de l'instant.",
    "Parfois, ce n'est qu'après s'être arrêtée un moment que l'on réalise à quel point on en avait besoin.",
  ],
  quiTitle: "Qui suis-je ?",
  qui: [
    "Je suis Nina, esthéticienne et fondatrice de Ninaa Beauty.",
    "Depuis mon enfance, je suis attirée par l'univers de la beauté, mais aussi par la créativité et cette curiosité qui me pousse à aller au-delà de ce que l'on voit.",
    "En choisissant l'esthétique, j'ai rapidement compris que je voulais lui donner une dimension qui me ressemble : prendre le temps, être attentive à chaque femme que je reçois et créer une approche où le soin ne s'arrête pas seulement à la prestation, mais aussi à la façon dont elle est vécue.",
    "Une manière pour moi de faire de ce métier un espace de créativité, de partage et de bien-être, nourri par les inspirations, les rencontres et tout ce qui reste encore à imaginer… !",
  ],
  founderImage:
    "https://customer-assets-wrfwihn1.emergentagent.net/job_site-studio-342/artifacts/gqmxtmgy_IMG_8242.webp",
};



// Préparer votre rendez-vous — informations pratiques (accordéon page Contact)
export const PREPARE_VISIT = [
  {
    t: "Accès à l'Institut",
    d: "Ninaa Beauty se situe au 31 rue du Rempart Matabiau, au 3e étage.\n\nL'institut n'a pas de devanture : entrez par la porte métallique au niveau des plaques professionnelles et sonnez à l'interphone Ninaa Beauty, même si la porte est ouverte.\n\nAscenseur disponible jusqu'au 3e étage. Une fois entrée dans l'institut, vous pourrez retirer vos chaussures et vous installer dans l'espace d'attente.",
  },
  {
    t: "Venir à l'Institut",
    d: "Stationnement : parkings Victor-Hugo et Jean-Jaurès à proximité.\n\nMétro : Jeanne d'Arc (ligne B) • Jean-Jaurès (lignes A et B)",
  },
  {
    t: "Autres informations pratiques",
    d: "En cas de retard, merci de me prévenir au 07 44 97 22 82.\nAu-delà de 10 minutes, le rendez-vous pourra être annulé afin de ne pas décaler les suivants.\n\nLes rendez-vous se déroulent sans accompagnant, enfant ni animal.\n\nMerci de mettre votre téléphone en silencieux pendant la prestation.\n\nRèglement par carte bancaire ou espèces.",
  },
];
